import React from 'react';
import { useSelector } from 'react-redux';

import { useConfig } from 'ha/helpers/config';

import { getAdvertiser, getIsBelongsToPartner } from '../selectors';

export function useStudapart() {
  const { studapart } = useConfig();
  const advertiser = useSelector(getAdvertiser);
  const isBelongsToPartner = useSelector(getIsBelongsToPartner);

  const res = React.useMemo(
    () => ({
      isStudapartListing:
        isBelongsToPartner && advertiser.id === studapart.advertiserId,
    }),
    [isBelongsToPartner, advertiser.id, studapart.advertiserId],
  );

  return res;
}
